import { render } from "./CreateContacts.vue?vue&type=template&id=0cb25c4e"
import script from "./CreateContacts.vue?vue&type=script&lang=js"
export * from "./CreateContacts.vue?vue&type=script&lang=js"

import exportComponent from "/Users/souban/Documents/Code/Amaze-Portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__